import React, { useState } from "react";
import { API_BASE_URL } from "../../config";
import { createRoot } from "react-dom/client";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

let root;
let setLessonGlobal;

const backdropStyle = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "12px",
  boxSizing: "border-box",
  zIndex: 9999,
};

const modalStyle = {
  background: "#fff",
  padding: "clamp(16px, 4vw, 32px)",
  borderRadius: "12px",
  width: "min(100%, 680px)",
  maxWidth: "100%",
  maxHeight: "88dvh",
  overflowY: "auto",
  boxSizing: "border-box",
  boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
};

function LessonModal({ lesson, onClose, onStart }) {
  if (!lesson) return null;

  return (
    <div style={backdropStyle} onClick={onClose}>
      <div style={modalStyle} onClick={e => e.stopPropagation()}>
        <h2 style={{ fontSize: "clamp(1.2rem, 3vw, 1.55rem)", margin: "4px 0 8px", textAlign: "center" }}>{lesson.title || "Lesson Info"}</h2>
        {lesson.subtitle && <p className="lesson-tile__subtitle" style={{ textAlign: "center", marginTop: "0px", marginBottom: "16px" }}>{lesson.subtitle}</p>}
        <div className="lesson-markdown-body">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{lesson.text}</ReactMarkdown>
        </div>
        <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "10px", marginTop: "20px" }}>
          <button className="lesson-tile__btn lesson-tile__btn--primary" onClick={onStart}>Start Lesson</button>
          <button className="lesson-tile__btn lesson-tile__btn--secondary" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}

function ModalHost({ onStart }) {
  const [lesson, setLesson] = useState(null);
  setLessonGlobal = setLesson;

  const handleClose = () => setLesson(null);
  return <LessonModal lesson={lesson} onClose={handleClose} onStart={onStart} />;
}

function ensureRoot(onStart) {
  if (root) return;

  const container = document.createElement("div");
  document.body.appendChild(container);
  root = createRoot(container);
  root.render(<ModalHost onStart={onStart} />);
}

export async function openLessonPopup(lessonId, onStart) {
  ensureRoot(onStart);

  const res = await fetch(
    `${API_BASE_URL}/api/lesson-card?lesson_id=${lessonId}`
  );

  const data = await res.json();
  if (data.error) return;
  setLessonGlobal(data);
}
